import {
    SIGN_IN,
    SIGN_OUT,
    USER_NAME,
    USER_DETAIL,
    CODE_ASANA,
    SIGN_OUT_OBJ,
    MESSAGE_POPUP,
    NEW_USER,
    NEW_USER_DETAIL,
    CHAT_ON,
    CHAT_OFF,
    LIST_LESSONS,
    STEP_ONBOARDING,
    STATE_CHAT,
    SELECT_OBJETIVE,
    LIST_OBJETIVES,
    END_CHAT,
    MESSAGE_CHAT,
    ON_MESSAGE,
    NUM_TASK_END,
    QUERY_DB,
    UTILS_USER,
    CONTROL_FLOW_CX,
}
    from '../actions/types';

// inicio con firebase
import firebase from 'firebase';
import { config } from '../apis/firebaseConnetion';
firebase.initializeApp(config);

const INITIAL_STATE = {
    isSignedIn: null,
    userId: null,
    userName: null,
    userDetail: null,
    messageAsana: null,
    signOutObj: null,
    messagePopup: null,
    newUser: null,
    newUserDetail: null,
    isChat: null,
    listLesson: null,
    stepOnboarding: null,
    stateChat: null,
    selectObjective: null,
    listObjetive: null,
    endChatmessage: null,
    message: null,
    onMessageChat: null,
    numTaskEnd: null,
    query: null,
    userUtil: null,
    controlFlow: null,
};



export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CHAT_ON:
            return { ...state, isChat: true };
        case CHAT_OFF:
            return { ...state, isChat: false };
        case SIGN_IN:
            return { ...state, isSignedIn: true, userId: action.payload };
        case SIGN_OUT:
            return { ...state, isSignedIn: false, userId: null };
        case USER_NAME:
            return { ...state, userName: action.payload };
        case USER_DETAIL:
            return { ...state, userDetail: action.payload };
        case CODE_ASANA:
            return { ...state, messageAsana: action.payload };
        case SIGN_OUT_OBJ:
            return { ...state, signOutObj: action.payload };
        case MESSAGE_POPUP:
            return { ...state, messagePopup: action.payload };
        case NEW_USER:
            return { ...state, newUser: action.payload };
        case NEW_USER_DETAIL:
            return { ...state, newUserDetail: action.payload };
        case LIST_LESSONS:
            return { ...state, listLesson: action.payload };
        case STEP_ONBOARDING:
            return { ...state, stepOnboarding: action.payload };
        case STATE_CHAT:
            return { ...state, stateChat: action.payload };
        case SELECT_OBJETIVE:
            return { ...state, selectObjective: action.payload };
        case LIST_OBJETIVES:
            return { ...state, listObjetive: action.payload };
        case END_CHAT:
            return { ...state, endChatmessage: action.payload };
        case MESSAGE_CHAT:
            return { ...state, message: action.payload };
        case ON_MESSAGE:
            return { ...state, onMessageChat: action.payload };
        case NUM_TASK_END:
            return { ...state, numTaskEnd: action.payload };
        case QUERY_DB:
            return { ...state, query: action.payload };
        case UTILS_USER:
            return { ...state, userUtil: action.payload };
        case CONTROL_FLOW_CX:
            return { ...state, controlFlow: action.payload };


        default:
            return state;
    }
};